// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { Scroller, Slider, Image, Overlay, Buttons } from '@cian/slider';
import * as React from 'react';

import { PaginationDots } from './components/PaginationDots';
import { Stub } from './components/Stub';
import { IPhotoMobSiteSchema } from '../../types/recommendation';

interface ICarouselProps {
  desktopControls?: boolean;
  media: IPhotoMobSiteSchema[];
  onSlideChange?(index: number): void;
}

export const Carousel: React.FC<ICarouselProps> = ({ desktopControls, media, onSlideChange }) => {
  const showButtons = React.useMemo(() => media.length > 1, [media]);

  if (media.length === 0) {
    return <Stub />;
  }

  return (
    <Slider onSlideChange={onSlideChange}>
      <Scroller>
        {media.map(mediaRaw => (
          <Image key={mediaRaw.id} src={mediaRaw.url} />
        ))}
      </Scroller>
      <Overlay hideable={false}>
        {desktopControls && showButtons && <Buttons />}
        {showButtons && <PaginationDots />}
      </Overlay>
    </Slider>
  );
};
